import React from 'react';
import LogInForm from '../../Account/LogIn/components/LogInForm';

const LimeProxyLogin = () => (
  <div className="account account--photo">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__head">
          <h3 className="account__title">
            Welcome to&nbsp;
            <span className="account__logo">
              Lime
              <span className="account__logo-accent">Proxies</span>
            </span>
          </h3>
        </div>
        <LogInForm onSubmit />
      </div>
    </div>
  </div>
);

export default LimeProxyLogin;
